import {
  Dialog as MuiDialog,
  DialogProps as MuiDialogProps,
  styled,
  keyframes,
} from '@mui/material';

import loadingCube from '../../assets/svg/loading_cube.svg';
import loadingRing from '../../assets/svg/loading_ring.svg';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Dialog = styled(MuiDialog)`
  & .MuiPaper-root {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
    overflow: visible;
    background: #fff;
  }
`;

const LoadingWrapper = styled('div')`
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CubeImg = styled('img')`
  position: absolute;
  width: 50px;
  height: 59.045px;
  top: 25%;
  left: 30%;
`;

const RingImg = styled('img')`
  position: absolute;
  inset: 8.33%;
  width: calc(100% - 16.66%);
  height: calc(100% - 16.66%);
  animation: ${spin} 1.5s linear infinite;
`;

interface ProgressingDialogProps extends Omit<MuiDialogProps, 'children'> {
  zIndex?: number;
}

const ProgressingDialog: React.FC<ProgressingDialogProps> = ({
  zIndex,
  ...props
}) => {
  return (
    <Dialog sx={{ zIndex }} {...props}>
      <LoadingWrapper>
        <CubeImg src={loadingCube} alt="" />
        <RingImg src={loadingRing} alt="" />
      </LoadingWrapper>
    </Dialog>
  );
};

export default ProgressingDialog;
